<template>
  <form class="card pa-40">
    <section class="card-content">
      <h1 class="is-size-6 has-text-weight-bold has-text-grid-1 mb-20">
        {{ trad.titre }}
      </h1>
      <msg-error v-if="!!msgError" type="is-danger" :msg="msgError" @close="msgError = ''"/>
      <b-field>
        <template slot="label">
          <qd-label :label="trad.libelle" required />
        </template>
        <b-input v-model="libelle"></b-input>
      </b-field>
    </section>
    <footer class="has-text-centered mt-10">
      <b-button
        type="is-transparent"
        class="has-text-default"
        @click="cancelModal">
        {{ $t('general.btnAnnuler') }}
      </b-button>
      <b-button
        type="is-primary"
        class="has-text-weight-bold ml-20"
        @click="saveItem">
        {{ $t('general.btnAjouter') }}
      </b-button>
    </footer>
  </form>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { create } from '@/api/parametrage';
import QdLabel from '@/components/general/qdLabel.vue';
import MsgError from '@/components/general/messageErreur';
import gestionErreur from '@/services/general/gestionErreur';

const Parametres = createNamespacedHelpers('parametrage');

export default {
  components: {
    QdLabel,
    MsgError,
  },
  props: {
    libelleValue: {
      type: String,
      required: false,
      default: '',
    },
    target: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      msgError: '',
      libelle: '',
      isError: false,
    }
  },
  computed: {
    trad() {
      return {
        element: this.$t(`parametre.${this.target}.element`),
        titre: this.$t(`parametre.${this.target}.titleCreate`),
        libelle: this.$t(`parametre.${this.target}.libelleChamp`),
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    cancelModal() {
      this.libelle = '';
      this.msgError = '';
      this.$emit('close');
    },
    async saveItem() {
      if (!this.libelle) {
        this.msgError = this.$t('general.msgErrorChampObligatoire');
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        const payload = { libelle: this.libelle };
        const result = (await create(this.target, payload)).data.result;
        await this.loadParametreForce(this.target);
        this.$emit('reloadParametrage', result);
        this.cancelModal();
      } catch (error) {
        gestionErreur(`Error lors de la création d'${this.trad.element}`);
        throw error;
      } finally {
        loadingComponent.close();
      }
    },
  },
  mounted() {
    this.libelle = this.libelleValue;
  },
};
</script>
